type AgendaItemLocationProps = {
    displayName: string;
    locationType: string;
    uniqueIdType: string;
};

export default class AgendaItemLocation {
    displayName: string;

    locationType: string;

    uniqueIdType: string;

    constructor({
        displayName,
        locationType,
        uniqueIdType,
    }: AgendaItemLocationProps) {
        this.displayName = displayName;
        this.locationType = locationType;
        this.uniqueIdType = uniqueIdType;
    }
}
